export default{
    created(){
        const token = JSON.parse(this.$localStorage.get('token'))
        if (!token) {
          this.$router.push('/')
        }
      }
}


// WEBPACK FOOTER //
// ./src/mixins/sesion.js